// New component: TireCodeSelectorModal.tsx
"use client";

import React, { useEffect } from "react";
import { tireCodes } from "@/app/constants/tireCodes";
import { createPortal } from "react-dom";

interface TireCodeSelectorModalProps {
  onClose: () => void;
  onSelect: (code: string) => void;
}

const TireCodeSelectorModal: React.FC<TireCodeSelectorModalProps> = ({
  onClose,
  onSelect,
}) => {
  // Add Escape key close
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return createPortal(
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white p-6 rounded-xl w-[90%] max-h-[90%] overflow-auto"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Selecteer een bandcode</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 cursor-pointer transition-all duration-200 ease-in-out w-12 h-12 text-5xl flex items-center justify-center"
          >
            X
          </button>
        </div>
        <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 gap-4">
          {tireCodes.map((code) => (
            <button
              key={code}
              onClick={() => {
                onSelect(code);
                onClose();
              }}
              className="bg-gray-100 hover:bg-gray-200 rounded-lg p-6 text-center text-2xl font-semibold cursor-pointer transition-all duration-200 ease-in-out transform hover:scale-105"
            >
              {code}
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TireCodeSelectorModal;
